import { prefersReducedMotion } from './motion';

/**
 * Reveal-on-scroll. Elements marked `.reveal` fade and rise into view once.
 * The hidden starting state lives in CSS behind `.js-enabled`, so with no
 * JavaScript everything is simply visible. Under reduced motion we mark all
 * elements visible immediately and never observe.
 */
export function initReveal(): void {
  const elements = Array.from(document.querySelectorAll<HTMLElement>('.reveal'));
  if (elements.length === 0) return;

  if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
    elements.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
  );

  elements.forEach((el) => observer.observe(el));
}
